module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-11.4dc932cf.svg";